import {request} from '@/utils/http';


let addcollect = '/fronted/favorite/save'
let collectliSt = '/fronted/favorite/page'
let iscollect = '/fronted/favorite/isFavorite'
let cancelcollect = '/fronted/favorite/cancel'

export function POST_ADDCOLLECT(params){
  return request(addcollect,'POST',params)
}
export function GET_COLLECTLIST(params){
  return request(collectliSt,'GET',params)
}
export function POST_ISCOLLECT(params){
  return request(iscollect,'POST',params)
}
export function POST_CANCELCOLLECT(params){
  return request(cancelcollect,'POST',params)
}



// WEBPACK FOOTER //
// ./src/api/collect.api.js